import React from 'react';
import {
  Menu,
  Users,
  ClipboardList,
  Activity,
  Scale,
  Settings,
  Circle,
  Loader,
  Ban,
} from 'lucide-react';
import { getStatusMeta } from '../utils/format';
import styles from './Header.module.css';

const ICONS = {
  org: Users,
  tasks: ClipboardList,
  activity: Activity,
  decisions: Scale,
  settings: Settings,
};

const MODE_META = {
  normal: { label: 'Normal Ops', icon: Circle },
  sprint: { label: 'Sprint Mode', icon: Loader },
  crisis: { label: 'Crisis Mode', icon: Ban },
};

export function Header({ tabs, activeTab, onTabChange, mode }) {
  const modeKey = mode || 'normal';
  const modeMeta = MODE_META[modeKey] || MODE_META.normal;
  const ModeIcon = modeMeta.icon;
  const statusMeta = getStatusMeta(modeKey === 'crisis' ? 'blocked' : modeKey === 'sprint' ? 'working' : 'idle');

  return (
    <header className={styles.header}>
      <button className={styles.menuButton} aria-label="Open menu" type="button">
        <Menu size={20} />
      </button>

      <div className={styles.brand}>Company Command</div>

      <nav className={styles.nav} aria-label="Main navigation">
        {Object.entries(tabs).map(([key, label]) => {
          const Icon = ICONS[key];
          const isActive = key === activeTab;
          return (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={`panel-${key}`}
              className={`${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
              onClick={() => onTabChange(key)}
            >
              <Icon size={16} aria-hidden="true" />
              <span>{label}</span>
            </button>
          );
        })}
      </nav>

      <div
        className={styles.modeIndicator}
        style={{
          backgroundColor: `${statusMeta.color}12`,
          color: statusMeta.color,
        }}
        aria-live="assertive"
      >
        <ModeIcon size={14} aria-hidden="true" />
        <span>{modeMeta.label}</span>
      </div>
    </header>
  );
}
